// extracted by mini-css-extract-plugin
export default {"container":"CreateClient_container__md4j-"};